import { Link } from "react-router-dom";
import { User, Dumbbell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { STAFF, BIO_PLACEHOLDER } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";
import { TrainingDialog } from "@/components/dialogs/TrainingDialog";

function initials(name) {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export function Staff() {
  return (
    <section id="staff" className="relative py-20 sm:py-28 lg:py-32 bg-ink-900 overflow-hidden">
      <div className="absolute inset-0 diag-stripe opacity-30" />
      <div className="container-x relative">
        <Reveal className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-blaze-orange">The Sideline</span>
          <h2 className="mt-3 font-display font-black uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white leading-none">
            Meet Our <span className="text-gradient-blaze">Staff</span>
          </h2>
          <p className="mt-5 text-lg text-white/70 leading-relaxed">
            Knowledgeable coaches who love the game and take pride in developing every player.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {STAFF.map((c, i) => (
            <Reveal key={c.name} delay={(i % 3) * 0.08}>
              <div
                data-testid={`staff-card-${i}`}
                className="hover-lift group h-full rounded-2xl border border-white/10 bg-ink-700 p-6 hover:border-blaze-blueLight/50"
              >
                <div className="flex items-center gap-4">
                  {c.photo ? (
                    <div className="relative h-16 w-16 shrink-0 overflow-hidden rounded-xl shadow-lg ring-2 ring-blaze-blue/40">
                      <img src={c.photo} alt={`${c.name}, CT Blazers ${c.position}`} className="h-full w-full object-cover object-top" />
                    </div>
                  ) : (
                    <div className="relative grid h-16 w-16 shrink-0 place-items-center rounded-xl bg-gradient-to-br from-blaze-blue to-blaze-blueLight text-white font-heading text-2xl tracking-wide shadow-lg">
                      {initials(c.name)}
                      <User size={14} className="absolute -bottom-1 -right-1 rounded-full bg-blaze-orange p-0.5 text-ink-900" />
                    </div>
                  )}
                  <div>
                    <h3 className="font-heading text-2xl tracking-wide text-white leading-none">{c.name}</h3>
                    <p className="mt-1 text-xs font-bold uppercase tracking-wider text-blaze-orange">{c.position}</p>
                  </div>
                </div>
                <p className={`mt-4 text-sm leading-relaxed ${c.bio ? "text-white/70" : "text-white/55 italic"}`}>
                  {c.bio || BIO_PLACEHOLDER}
                </p>
                <div className="mt-5">
                  {c.training ? (
                    <TrainingDialog coach={c.name}>
                      <Button
                        data-testid={`staff-contact-${i}`}
                        className="w-full bg-blaze-blue/15 hover:bg-blaze-blue text-white border border-blaze-blue/40 font-bold uppercase tracking-wide text-xs rounded-full h-10 transition-all"
                      >
                        <Dumbbell size={15} className="mr-1.5" /> Contact for Training
                      </Button>
                    </TrainingDialog>
                  ) : (
                    <Button
                      asChild
                      data-testid={`staff-contact-${i}`}
                      className="w-full bg-white/5 hover:bg-white/10 text-white/80 border border-white/10 font-bold uppercase tracking-wide text-xs rounded-full h-10"
                    >
                      <Link to="/#contact">Contact</Link>
                    </Button>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
